import React, { useState } from "react";
import { DatePicker3 } from "@blueprintjs/datetime2";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/datetime2/lib/css/blueprint-datetime2.css";
import { StyledButton, StyledDatePickerContainer, StyledActionButtons } from "./styles";

function BaseDatePicker(props) {
  const { buttonLabel, open, setDateField, defaultValue } = props;

  const [date, setDate] = useState(defaultValue);

  const handleDateChange = (dateSelected) => {
    setDate(dateSelected);
  };

  const onClose = (saveDate) => {
    if (saveDate) {
      setDateField(date);
    }
  };

  return (
    <StyledDatePickerContainer open={open}>
      <DatePicker3
        onChange={handleDateChange}
        canClearSelection={false}
        timePickerProps={{ showArrowButtons: true, precision: "second" }}
        {...props}
      />
      <StyledActionButtons>
        <StyledButton fullWidth variant="contained" color="primary" disableElevation onClick={onClose}>
          {buttonLabel || "Set Date"}
        </StyledButton>
        <StyledButton fullWidth className="default" variant="contained" disableElevation onClick={onClose}>
          Cancel
        </StyledButton>
      </StyledActionButtons>
    </StyledDatePickerContainer>
  );
}

export default BaseDatePicker;
